<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <div>
      <div v-if="erroGuidFaltando" class="p-50">
        <b-card class="text-center f-g">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 132.2 132.2"
            class="banner-svg"
          >
            <circle
              class="path circle"
              fill="none"
              stroke="#D06079"
              stroke-width="6"
              stroke-miterlimit="10"
              cx="65.1"
              cy="65.1"
              r="62.1"
            ></circle>
            <line
              class="path line"
              fill="none"
              stroke="#D06079"
              stroke-width="6"
              stroke-linecap="round"
              stroke-miterlimit="10"
              x1="34.4"
              y1="37.9"
              x2="95.8"
              y2="92.3"
            ></line>
            <line
              class="path line"
              fill="none"
              stroke="#D06079"
              stroke-width="6"
              stroke-linecap="round"
              stroke-miterlimit="10"
              x1="95.8"
              y1="38"
              x2="34.4"
              y2="92.2"
            ></line>
          </svg>
          <h4>Desculpe, não conseguimos processar seu pedido</h4>
          <h5>Verifique seu e-mail novamente ou entre em contato conosco!</h5>
        </b-card>
      </div>

      <div v-if="sucesso" class="p-50">
        <b-card class="text-center f-g">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 132.2 132.2"
            class="banner-svg"
          >
            <circle
              class="path circle"
              fill="none"
              stroke="#73AF55"
              stroke-width="6"
              stroke-miterlimit="10"
              cx="65.1"
              cy="65.1"
              r="62.1"
            ></circle>
            <polyline
              class="path check"
              fill="none"
              stroke="#73AF55"
              stroke-width="6"
              stroke-linecap="round"
              stroke-miterlimit="10"
              points="100.2,40.2 51.5,88.8 29.8,67.5 "
            ></polyline>
          </svg>
          <h4>Parabéns, seu cadastro foi ativado com sucesso!</h4>
        </b-card>
      </div>

      <div v-if="problema" class="p-50">
        <b-card class="text-center f-g">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 132.2 132.2"
            class="banner-svg"
          >
            <circle
              class="path circle"
              fill="none"
              stroke="#D06079"
              stroke-width="6"
              stroke-miterlimit="10"
              cx="65.1"
              cy="65.1"
              r="62.1"
            ></circle>
            <line
              class="path line"
              fill="none"
              stroke="#D06079"
              stroke-width="6"
              stroke-linecap="round"
              stroke-miterlimit="10"
              x1="34.4"
              y1="37.9"
              x2="95.8"
              y2="92.3"
            ></line>
            <line
              class="path line"
              fill="none"
              stroke="#D06079"
              stroke-width="6"
              stroke-linecap="round"
              stroke-miterlimit="10"
              x1="95.8"
              y1="38"
              x2="34.4"
              y2="92.2"
            ></line>
          </svg>
          <h4>Desculpe, não conseguimos achar esse cadastro</h4>
        </b-card>
      </div>

      <div v-if="emailAlreadyActivated" class="p-50">
        <b-card class="text-center f-g">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 132.2 132.2"
            class="banner-svg"
          >
            <circle
              class="path circle"
              fill="none"
              stroke="#D7D41E"
              stroke-width="6"
              stroke-miterlimit="10"
              cx="65.1"
              cy="65.1"
              r="62.1"
            ></circle>
            <polyline
              class="path check"
              fill="none"
              stroke="#D7D41E"
              stroke-width="6"
              stroke-linecap="round"
              stroke-miterlimit="10"
              points="100.2,40.2 51.5,88.8 29.8,67.5 "
            ></polyline>
          </svg>
          <h4>O e-mail já está ativo!</h4>
          <h5>Você já pode utilizar o aplicativo.</h5>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";

import * as config from "@/config.json";

export default {
  name: "Login",
  components: { Loading },
  data() {
    return {
      isLoading: true,
      erroGuidFaltando: false,
      sucesso: false,
      problema: false,
      guidParametro: "",
      emailAlreadyActivated: false,
    };
  },
  methods: {
    handleSubmit() {
      window.location.href = "http://www.accesys.com.br/supermercado/";
    },

    async verificaEmail() {
      this.isLoading = true;

      const url =
        `${config.default.servidor}/registro/verificar-email/` +
        this.guidParametro;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: {
            Authorization: "Basic c2E6QURNQUNDRVNZUw==",
          },
        });

        this.isLoading = false;

        if (!response.data.error) {
          this.sucesso = true;
          this.problema = false;
          this.emailAlreadyActivated = false;
        } else {
          this.sucesso = false;
          this.problema = true;
          this.emailAlreadyActivated = false;
        }
      } catch (error) {
        console.log({ error });
        this.isLoading = false;
        if (error.response.data.errorMessage == "Email já ativado") {
          this.emailAlreadyActivated = true;
          this.problema = false;
          this.sucesso = false;
        } else {
          this.sucesso = false;
          this.problema = true;
          this.emailAlreadyActivated = false;
        }
      }
    },
  },
  async beforeMount() {
    this.isLoading = true;
    this.guidParametro = this.$route.query.guid;

    if (this.guidParametro != undefined && this.guidParametro != "") {
      await this.verificaEmail();
    } else {
      this.isLoading = false;
      this.erroGuidFaltando = true;
    }
  },
};
</script>
